// src/components/ChatWindow/index.js
import ChatWindow from './ChatWindow';
export default ChatWindow;